/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Type_ApartmentInputs */

const cs_public_site_demand_type_apartment = /** @type {(inputs: Public_Site_Demand_Type_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Byt`)
};

const en_public_site_demand_type_apartment = /** @type {(inputs: Public_Site_Demand_Type_ApartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartment`)
};

/**
* | output |
* | --- |
* | "Apartment" |
*
* @param {Public_Site_Demand_Type_ApartmentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_type_apartment = /** @type {((inputs?: Public_Site_Demand_Type_ApartmentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Type_ApartmentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_type_apartment(inputs)
	return cs_public_site_demand_type_apartment(inputs)
});